var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocialMediaTiktok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M31.93,15.15v-5.51c-1.54,0-2.96-.46-4.17-1.24-1.71-1.11-2.97-2.92-3.34-5.01-.09-.46-.13-.91-.13-1.39h-5.51v22.07c-.09,2.48-2.11,4.47-4.61,4.47-.78,0-1.52-.2-2.16-.54-1.47-.77-2.48-2.33-2.48-4.1,0-2.56,2.08-4.64,4.64-4.64.47,0,.94.09,1.37.21v-5.62c-.46-.06-.9-.11-1.37-.11-5.59,0-10.13,4.55-10.13,10.13,0,3.44,1.72,6.47,4.33,8.3,1.65,1.15,3.66,1.84,5.81,1.84,5.59,0,10.13-4.54,10.13-10.13v-11.18c2.16,1.54,4.81,2.45,7.65,2.45h-.04v-.03.04Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialMediaTiktok);
export default __webpack_public_path__ + "static/media/icon-social-media-tiktok.c7d252634fea3c5497006c01ec2d0839.svg";
export { ForwardRef as ReactComponent };